import React from 'react';
import { COMPANIES } from '../data';
import './Clients.css';

export default function Clients() {
  return (
    <section className="clients">
      <div className="container">
        <p className="clients__label">Trusted by</p>
        <div className="clients__grid">
          {COMPANIES.map((company, i) => (
            <div key={i} className="clients__logo-wrap">
              {company.logo ? (
                <img src={company.logo} alt={company.name} className="clients__logo" />
              ) : (
                <span className="clients__logo-text">{company.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
